import { Injectable } from '@angular/core';
import { RootService } from '@app/core/root.service';
import { ItemProps } from '@app/interfaces';
import { Router } from '@angular/router';
import { ApiRequestService } from '@app/core/http/api-request.service';
import { Validators, FormGroup } from '@angular/forms';
import { PermissionsService } from '@app/core/permissions/permissions.service';
import { CustomValidators } from '@app/core/classes/custom-validators/custom-validators';
import { SharedService } from '@app/shared/services/shared.service';
import { ToArabicPipe } from '@app/shared/pipes/toArabic.pipe';
import { TranslateService } from '@ngx-translate/core';
import { permissions } from './permissions';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RolesService extends RootService {
  searchKey = 'keyword';
  checkboxesValues = {};
  update_form: Subject<any> = new Subject();
  form: FormGroup;
  constructor(
    router: Router,
    api: ApiRequestService,
    shared: SharedService,
    permissionsService: PermissionsService,
    private toArabic: ToArabicPipe,
    private translateService: TranslateService
  ) {
    super(router, api, permissionsService, shared);
    this.permissionsKey = 'role';

    // this.lists.notifications = [
    //   {
    //     id: 1,
    //     name: 'Driver'
    //   },
    //   {
    //     id: 2,
    //     name: 'Technician'
    //   },
    //   {
    //     id: 3,
    //     name: 'Employee'
    //   },
    //   {
    //     id: 4,
    //     name: 'Administrator'
    //   }
    // ];
  }
  routerPrefix(val: string = '') {
    return val ? val : 'roles';
  }
  refactorCheckboxesValues(chValues: {}, list: {}) {
    // console.log('chValues', chValues);
    // console.log('list', list);
    for (const key in list) {
      if ((list as any)[key].length) {
        (list as any)[key].forEach((element: any) => {
          element['is_selected'] = (chValues as any)[key][element['name']];
        });
      }
    }
    // console.log('list after refactor', list);
    let finalList = JSON.parse(JSON.stringify(list));
    for (const key in finalList) {
      if (finalList[key].length) {
        finalList[key] = finalList[key].filter((d: any) => d.is_selected).map((filterd: any) => filterd.id);
      }
    }
    for (const key in finalList) {
      finalList[key] = finalList[key].filter((d: any) => !!d);
    }
    // console.log("final", finalList);
    return finalList;
  }
  selectItem(id: any) {
    if (Array.isArray(id)) {
      id = id.filter(id => id !== 1);
    }
    if (id.constructor === Array) {
      if (this.selectedItems.length) {
        if (this.selectedItems.length === id.length) {
          id.forEach((y: number) => {
            if (this.selectedItems.find(x => x === y)) {
              const i = this.selectedItems.findIndex(x => x === y);
              this.selectedItems.splice(i, 1);
            } else {
              this.selectedItems.push(y);
            }
          });
        } else {
          id.forEach((y: number) => {
            if (this.selectedItems.find(x => x === y)) {
              // const i = this.selectedItems.findIndex(x => x === y);
              // this.selectedItems.splice(i, 1);
            } else {
              this.selectedItems.push(y);
            }
          });
        }
      } else {
        id.forEach((y: number) => {
          this.selectedItems.push(y);
        });
      }
      this.selectedItems$.next(null);
    } else if (typeof id === 'number') {
      if (this.selectedItems.length) {
        if (this.selectedItems.find(x => x === id)) {
          const i = this.selectedItems.findIndex(x => x === id);
          this.selectedItems.splice(i, 1);
        } else {
          this.selectedItems.push(id);
        }
      } else {
        this.selectedItems.push(id);
      }
      this.selectedItems$.next(null);
    }
  }

  refactorItem(item: any) {
    // console.log('form in edit', item);
    // item.permissions = this.sortingPermissons(item.permissions);
    item.permissions.permission.push({});
    this.update_form.next({ data: item.permissions });
    return item;
  }

  refactorSelectListsResponse(listPrefix: string, response: any, listPaginate: boolean = false) {
    // console.log("listPrefix", listPrefix);
    // console.log("response", response);
    // response.data.permission.push({});
    if (listPrefix === 'notifications') {
      // console.log("notifications done", response);
      delete response['name'];
      response['data'].forEach((e: any) => {
        delete e['name'];
        e['name'] = e['display_name'];
      });
    }
    if (listPrefix === 'permissions') {
      // console.log("permissions done", response);
      response.data.permission.push({});
    }
    return response.data;
  }

  refactorFormBeforeSubmit(formValue: any) {
    // console.log('formValue', JSON.stringify(formValue));
    // console.log('formValue', formValue);
    // console.log('formValueRaw: ', this.form.getRawValue());
    // formValue['role_name'] = this.form.getRawValue()['role_name'];
    // role_name getRawValue is handled inside roles-form.component.ts by overriding refactorFormBeforeSubmit
    formValue['permissions'] = this.refactorCheckboxesValues(this.checkboxesValues, this.lists.permissions);
    formValue['notifications'] = formValue['notifications'] ? formValue['notifications'] : [];
    return formValue;
  }

  refactorFilters(filters: any): any {
    super.refactorFilters(filters);
    /** set perPage to 50 */
    filters.per_page = 50;

    return filters;
  }

  listPrepareOperations(data: any) {
    super.listPrepareOperations(data);
    data['data'].forEach((element: any) => {
      element['users_count'] = this.setPrefixTd(element['users_count'], 'User');
    });

    return data;
  }

  setPrefixTd(num: number, name: string) {
    let str = '';
    if (!num) {
      str = 'لا يوجد';
    } else {
      str =
        num > 10 || num === 1
          ? `${this.toArabic.transform(num.toString())} ${
              this.translateService.instant(`${this.cid}`)[`single${name}`]
            }`
          : `${this.toArabic.transform(num.toString())} ${
              this.translateService.instant(`${this.cid}`)[`multi${name}`]
            }`;
    }
    return str;
  }

  get featureProps(): ItemProps[] {
    return [
      {
        name: 'role_name',
        prop: 'role_name',
        form: {
          formFieldType: 'text',
          maxLength: 50,
          minLength: 3,
          Validators: [Validators.required],
          disabeldIf: {
            key: 'id',
            value: 1
          }
        }
      },
      {
        name: 'notifications',
        prop: 'notifications',
        form: {
          formFieldType: 'ng_select_multiple_with_details',
          listPrefix: 'notifications',
          dataUrl: 'roles/notifications'
        }
      },

      {
        name: 'permissions',
        prop: 'permissions',
        form: {
          formFieldType: 'checkboxs_list',
          listPrefix: 'permissions',
          dataUrl: 'roles/permissions',
          disabeldIf: {
            key: 'id',
            value: 1
          }
        }
      },
      {
        name: 'display_name',
        prop: 'display_name',
        list: {
          sortable: true,
          searchable: true,
          // searchableInline: true,
          filterFieldType: 'text'
        }
      },
      {
        name: 'users_count',
        prop: 'users_count',
        list: {
          sortable: true,
          searchable: true,
          // searchableInline: true,
          filterFieldType: 'text',
          cellInnerCssClass: 'arabicFont'
        }
      }
    ];
  }
}
